import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { UpdateMobileNoStackRoutes, UpdateMobileNoStackScreenProps } from '@/features/account-management/screens/update-mobile-no/type';
import { UpdateMobileNoWebTwoScreen } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoWebTwo.screen';
import { UpdateMobileNoNativeTwoScreen } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoNativeTwo.screen';

export interface NewAccountProps {}
export const UpdateMobileNoPlaced: React.FC<UpdateMobileNoStackScreenProps<UpdateMobileNoStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, returnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <UpdateMobileNoNativeTwoScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        returnData={returnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <UpdateMobileNoWebTwoScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      returnData={returnData}
      refresh={refresh}
      record={record}
    />
  );
};
